import React, { useEffect, useState } from "react"
import { BlurhashCanvas } from "react-blurhash"
import SmartPicture from "react-smartpicture"

export interface ImageSurfaceProps {
  url?: string
  sources?: { media: string; srcSet: string }[]
  blurhash?: string
  width?: number
  height?: number
  focalPoint?: {
    x?: number
    y?: number
  }
}

const ImageSurface: React.FC<ImageSurfaceProps> = props => {
  const imgProportions =
    props.height && props.width ? props.height / props.width : 1
  const focalPoint = props.focalPoint || { x: 0.5, y: 0.5 }
  const [clientSideLoaded, setClientSideLoaded] = useState(false)
  const [hasResized, setHasResized] = useState(false)

  useEffect(() => {
    setClientSideLoaded(true)
  }, [props.url])

  return (
    <div className="c-image-surface">
      {props.blurhash && (
        <BlurhashCanvas
          className={`c-image-surface__blurhash ${
            !hasResized ? "" : "is-invisible"
          }`}
          hash={props.blurhash}
          width={32}
          height={Math.round(32 * imgProportions)}
          punch={1}
        />
      )}
      {props.url && clientSideLoaded && (
        <SmartPicture
          src={props.url}
          sources={props.sources}
          containerClassName={`c-image-surface__image ${
            !hasResized ? "is-invisible" : ""
          }`}
          focus={focalPoint}
          onResize={() => {
            hasResized || requestAnimationFrame(() => setHasResized(true))
          }}
        />
      )}
    </div>
  )
}

export default ImageSurface
